<template>
  <transition name="modal">
    <div class="modal-mask" v-bind:id="id">
      <div class="modal-wrapper">
        <div class="modal-dialog modal-container">
          <div class="modal-content">
            <div class="modal-header" v-if="!hideHeader">
              <slot name="modal-header">
                <h5 class="modal-title">
                  {{ title }}
                </h5>
              </slot>
            </div>

            <div slot="modal-subheader">
              <slot name="modal-subheader"></slot>
            </div>

            <div class="modal-body">
              <slot></slot>
            </div>

            <div class="modal-footer" v-if="!isHideFooter">
              <slot name="modal-footer" v-if="!isCustomFooter">
                <button type="button" class="btn btn-secondary" v-on:click="$emit('cancel')">
                  {{ closeTitle || $t('common.cancel') }}
                </button>
                <button type="button" class="btn btn-primary" v-on:click="$emit('ok')" v-bind:disabled="okDisabled">
                  <span v-if="!okBusy">{{ okTitle || $t('common.confirm') }}</span>
                  <LoadingBounce v-else></LoadingBounce>
                </button>
              </slot>
              <slot name="modal-footer" v-else />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'custom-modal',

    props: {
      id: String,
      title: String,
      okTitle: {
        type: String,
        default: null,
      },
      closeTitle: {
        type: String,
        default: null,
      },
      okDisabled: {
        type: Boolean,
        default: false,
      },
      okBusy: {
        type: Boolean,
        default: false,
      },
      hideHeader: {
        type: Boolean,
        default: false,
      },
      isHideFooter: {
        type: Boolean,
        default: false,
      },
      isCustomFooter: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/CustomModal.vue